import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import Callout from '../misc/Callout';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    const { children } = this.props;
    const { error, errorInfo } = this.state;
    if (error) {
      return (
        <div className="mb-3">
          <Callout severity="error" withInfoIcon>
            <details style={{ whiteSpace: 'pre-wrap' }}>
              <summary><LocalizedMessage id="error.errorBoundary" /></summary>
              {error && error.toString()}
              <br />
              {errorInfo.componentStack}
            </details>
          </Callout>
        </div>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

module.exports = ErrorBoundary;



// WEBPACK FOOTER //
// ./components/error/ErrorBoundary.js